import { Dispatch, FC, SetStateAction } from "react";
import TextInput from "../../UI/Inputs/TextInput";
import Checkbox from "../../UI/Inputs/Checkbox";
import KmSelector from "../../UI/KmSelector";

interface ListFilterProps {
    setSearchInput: Dispatch<SetStateAction<string>>
    selectCurrentListing: boolean
    selectWorkedAtPreviously: boolean
    selectDistanceAway: number
    setSelectCurrentListing: Dispatch<SetStateAction<boolean>>
    setSelectWorkedAtPreviously: Dispatch<SetStateAction<boolean>>
    setSelectDistanceAway: Dispatch<SetStateAction<number>>
}

const ListFilter: FC<ListFilterProps> = ({
  setSearchInput,
  selectCurrentListing,
  selectWorkedAtPreviously,
  selectDistanceAway,
  setSelectCurrentListing,
  setSelectWorkedAtPreviously,
  setSelectDistanceAway
}) => {

  const handleCheckBox = (checked: boolean, type: string) => {
    if(type === "current_listing"){
      setSelectCurrentListing(checked ? true : false)
    } else {
      setSelectWorkedAtPreviously(checked ? true : false)
    }
  }

  return (
    <>
      <div className="d-flex flex-column flex-lg-row gap-10 align-items-lg-center justify-content-lg-between">
        <div className="form-group w-200px mobile-w-100 input-icon icon-left">
          <TextInput
            placeholder="Search..."
            field="search"
            onChange={(e) => setSearchInput(e.target.value)}
            showSearchIcon={true}
            floatingLabel={false}
          />
        </div>
        <div className="d-flex flex-column flex-lg-row gap-25 gap-mobile-10 align-items-lg-center">
          <div className="theme-check">
            <Checkbox
              className="theme-check-input"
              id="current_listing"
              checked={selectCurrentListing}
              onChange={(e) => {
                handleCheckBox(e, "current_listing");
              }}
              labelFontSize={"13"}
              label={"Only Centres With Current Listings"}
              themeCheck={true}
            />
          </div>
          <div className="theme-check">
            <Checkbox
              className="theme-check-input"
              id="worked_at_previously"
              checked={selectWorkedAtPreviously}
              onChange={(e) => {
                handleCheckBox(e, "worked_at_previously");
              }}
              labelFontSize={"13"}
              label={"Only Centres Worked At Previously"}
              themeCheck={true}
            />
          </div>
          <div className="d-flex gap-3 align-items-center">
            <div className="fs-13 fw-400 text-black">Maximum distance away</div>
            <KmSelector 
              selectedDistancyAway={selectDistanceAway}
              setSelectedDistancyAway={setSelectDistanceAway}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ListFilter;
